import { IDataGridOptions, IColDef } from 'components/common/DataGridDevEx/DataGrid.properties';

import {
  createActions, asyncInitialState,
  IDataAction,
  IExtendedState
} from '../utils';

export interface ILotDetailsData {
  selected: any;
  gridOptions: IDataGridOptions;
  Columns: IColDef[];
}

export interface ILotDetailsState extends IExtendedState<ILotDetailsData> {
}

export const { types, actions } = createActions(
  {
    setSelected: (row) => ({ row }),
    asyncs: {

    }
  },
  'PMELotDetails');

const initialState = asyncInitialState<ILotDetailsData>({
  selected: null,
  gridOptions: {
  },
  Columns: [
    { headerName: 'Lot', field: 'LotSerial', minWidth: 150, suppressSorting: true, },
    { headerName: 'Description', field: 'Description', minWidth: 180, suppressSorting: true, },
    { headerName: 'Quantity', field: 'QuantityDisplay', type: 'numericColumn', minWidth: 180, suppressSorting: true, },
    { headerName: 'Cost/unit', field: 'CostDisplay', type: 'numericColumn', minWidth: 180, suppressSorting: true, },
    { headerName: 'Expiry', field: 'Expiry', minWidth: 150, suppressSorting: true, },
  ]
});

export default (state: ILotDetailsState = initialState, action: IDataAction): ILotDetailsState => {
  switch (action.type) {
    case types.setSelected:
      const selected = action.data.row;

      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      };
    default:
      return state;
  }
};

export const selectors = ({
  selected: (state: { pme: { lotDetails: ILotDetailsState } }) => state.pme.lotDetails.data.selected,
  gridOptions: (state: { pme: { lotDetails: ILotDetailsState } }) => state.pme.lotDetails.data.gridOptions,
  columns: (state: { pme: { lotDetails: ILotDetailsState } }) => state.pme.lotDetails.data.Columns
});
